/**
 * @generated SignedSource<<b00e9ec959dcda79a98f2f82a88077e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PagesListRow_page$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"SortableEntityTableRow_entity">;
  readonly " $fragmentType": "PagesListRow_page";
};
export type PagesListRow_page$key = {
  readonly " $data"?: PagesListRow_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"PagesListRow_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PagesListRow_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SortableEntityTableRow_entity"
    }
  ],
  "type": "Page",
  "abstractKey": null
};

(node as any).hash = "60f511f5313e6b3a4734e27fa9ebe5ce";

export default node;
